<template>
    <v-card>
        <v-data-iterator :items="projects" :items-per-page="2" :search="search">
            <template v-slot:header>
                <v-toolbar class="px-2">
                    <v-text-field v-model="search" density="comfortable" placeholder="Search"
                        prepend-inner-icon="mdi-magnify" style="max-width: 300px;" variant="solo" clearable
                        hide-details></v-text-field>
                </v-toolbar>
            </template>

            <template v-slot:default="{ items }">
                <v-container class="pa-2" fluid>
                    <v-row dense>
                        <v-col v-for="item in  items " :key="item.title" cols="auto" md="6">
                            <v-card class="pb-3" border flat>
                                <v-img :src="item.raw.img"></v-img>

                                <v-list-item :subtitle="item.raw.subtitle" class="mb-2">
                                    <template v-slot:title>
                                        <strong class="text-h6 mb-2">{{ item.raw.title }}</strong>
                                    </template>
                                </v-list-item>

                                <div class="d-flex justify-space-between px-4">
                                    <div class="d-flex align-center text-caption text-medium-emphasis me-1">
                                        <v-icon icon="mdi-office-building-marker" start></v-icon>

                                        <div class="text-truncate">{{ item.raw.client }}</div>
                                    </div>

                                    <v-btn v-bind:href=item.raw.url target="_blank" rel="noreferer noopener"
                                        class="text-none" size="small" text="Ver proyecto" border flat>
                                    </v-btn>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot:footer="{ page, pageCount, prevPage, nextPage }">
                <div class="d-flex align-center justify-center pa-4">
                    <v-btn :disabled="page === 1" density="comfortable" icon="mdi-arrow-left" variant="tonal" rounded
                        @click="prevPage"></v-btn>

                    <div class="mx-2 text-caption">
                        Page {{ page }} of {{ pageCount }}
                    </div>

                    <v-btn :disabled="page >= pageCount" density="comfortable" icon="mdi-arrow-right" variant="tonal"
                        rounded @click="nextPage"></v-btn>
                </div>
            </template>
        </v-data-iterator>
    </v-card>
</template>
<script>
export default {
    data: () => ({
        search: '',
        projects: [
            {
                img: '/img/AK_Envio.jpg',
                title: 'Cobertura de Envios',
                subtitle: 'Solución para descubrir la disponibilidad de envíos. Con nuestro buscador de cobertura, verifica rápidamente si entregamos en tu ciudad. ¡Ahorra tiempo y obtén respuestas inmediatas!',
                url: 'https://www.alkosto.com/entregas-devoluciones/envio-gratis',
                client: 'Alkosto',
            },
            {
                img: '/img/Compensar_inmue.jpg',
                title: 'Plataforma de Inmuebles',
                subtitle: 'Creamos una plataforma de inmuebles intuitiva y eficiente, con búsqueda instantánea y varios filtros para hallar tu hogar ideal rápidamente. Tecnología a la vanguardia para tu comodidad.',
                url: 'https://corporativo.compensar.com/vivienda/banco-de-inmuebles',
                client: 'Compensar',
            },
            {
                img: '/img/ALKP_OF.jpg',
                title: 'Ofertas Alkomprar',
                subtitle: 'Como empresa de desarrollo, creamos sitios de ofertas con carruseles de productos, elevando la experiencia de compra y potenciando negocios en el competitivo mercado del retail.',
                url: 'https://www.alkomprar.com/ofertas',
                client: 'Alkomprar',
            },
            {
                img: '/img/ihs.jpg',
                title: 'Site Home Solutions SPA',
                subtitle: 'Una plataforma para empresa chilena que ofrece servicios integrales de construcción, plomería, ubicación de fugas de agua y remodelación, mejorando la confianza y el contacto con el cliente.',
                url: 'https://homesolutionsspa.cl/',
                client: 'IHS Chile',
            },
            {
                img: '/img/ak_stores.jpg',
                title: 'UX/UI Tiendas Retail',
                subtitle: 'Desarrollamos sitios para retail con buscador instantáneo por ciudad, ofreciendo información actualizada sobre aperturas y horarios de tiendas, optimizando la experiencia del usuario.',
                url: 'https://www.alkosto.com/nuestra-compania/tiendas/c/tiendas',
                client: 'Alkosto',
            },
            {
                img: '/img/fqs.jpg',
                title: 'Preguntas frecuentes de vivienda',
                subtitle: 'Optimizamos la sección de FAQ de vivienda para Compensar, mejorando la accesibilidad a información clave incluyendo filtros de interés sobre trámites de vivienda para los usuarios.',
                url: 'https://corporativo.compensar.com/vivienda/tramites-vivienda/preguntas-frecuentes',
                client: 'Compensar',
            },
            {
                img: '/img/cyd.jpg',
                title: 'Políticas de Compras',
                subtitle: 'Implementamos la sección de cambios y devoluciones de Alkosto, facilitando a los usuarios un acceso claro y directo a las políticas de la empresa y mejorando claridad y accesibilidad de la información.',
                url: 'https://www.alkosto.com/politicas/cambios-devoluciones/c/cambios-devoluciones',
                client: 'Alkosto',
            },
            {
                img: '/img/cred_comp.jpg',
                title: 'Sitio web de Crédito',
                subtitle: 'Desarrollamos parte del sitio web de Crédito Compensar, ofreciendo soluciones financieras accesibles y confiables para nuestros clientes, con una experiencia de usuario optimizada y segura.',
                url: 'https://corporativo.compensar.com/credito',
                client: 'Compensar',
            },
        ],
    }),
}
</script>